import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import reducers from './reducers';

const middlewares = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (import.meta.env.NODE_ENV !== 'production') {
  middlewares.push(createLogger());
}

const store = createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));

export default store;
